(() => {
  const HEADING_SELECTOR = '.spice-spa-addon-heading[name="sg-pro-heading"]';

  // Find the smallest ancestor that contains the heading AND some inputs/selects
  function findWidgetContainer() {
    const heading = document.querySelector(HEADING_SELECTOR);
    if (!heading) return null;

    let el = heading;

    // climb up the DOM until we find a container that includes controls
    for (let i = 0; i < 12; i++) {
      const parent = el.parentElement;
      if (!parent) break;

      const hasControls =
        parent.querySelector('input, select, textarea, button, .spice-spa-addon, .spice-spa-addon-option') !== null;

      // this ensures we don’t grab the whole page, just a container that actually contains the options UI
      if (hasControls && parent.querySelector(HEADING_SELECTOR)) {
        return parent;
      }

      el = parent;
    }

    // fallback: if we never found a good wrapper, try a broader spice container
    return heading.closest('[class*="spice"]') || heading.parentElement;
  }

  function moveIfPossible() {
    const anchor = document.querySelector('.addon-options-anchor');
    if (!anchor) return false;

    const widget = findWidgetContainer();
    if (!widget) return false;

    if (anchor.contains(widget)) return true;
    anchor.appendChild(widget);
    return true;
  }

  // Try immediately
  moveIfPossible();

  // Keep watching: some apps rerender on variant changes, etc.
  const obs = new MutationObserver(() => {
    moveIfPossible();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
